
















import {Component, Prop, Vue} from 'vue-property-decorator';
import HistoryCardInfo from "@/views/components/History/HistoryCardInfo.vue";
import HistoryCardButton from "@/views/components/History/HistoryCardButton.vue";

import {IHistoryShipment} from "@/models/StoreModels";
import {namespace} from "vuex-class";
import {HISTORY, OTHER_ROUTES} from "@/constants/routes";
import {ShipmentLogic} from "@/models/ShipmentLogic";

const userDataModule = namespace('userData');

@Component({
  name: 'HistoryCard',
  components: {
    HistoryCardButton,
    HistoryCardInfo,
  },
})
export default class HistoryCard extends Vue {
  @userDataModule.Getter('getId')
  private userId!: number;

  @userDataModule.Getter('userSmsWasValidated')
  private userSmsWasValidated!: boolean;

  @Prop()
  private shipment!: IHistoryShipment;

  private openInfo() {
    this.$emit("shipmentInfo:show", this.shipment.id);
  }

  private openLocker() {
    this.$uiBus.emit("dropup:close");

    if (
        ShipmentLogic.userIsSender(this.shipment, this.userId) &&
        ShipmentLogic.isAwaitingDropoff(this.shipment)) {

      this.$router.push({name: OTHER_ROUTES.DEPOSIT_ITEM, params: { asId: `${this.shipment.id}` } });

    } else if (
        ShipmentLogic.userIsRecipient(this.shipment, this.userId) &&
        ShipmentLogic.isAwaitingPickup(this.shipment)
    ) {
      if (this.userSmsWasValidated) {
        this.$router.push({name: OTHER_ROUTES.PICKUP_ITEM, params: { asId: `${this.shipment.id}` } });
      } else {
        this.$uiBus.emit('genericError:show', this.$t('errors.validation'));
      }
    }
  }

  private selectHub() {
    if (this.userSmsWasValidated) {
      this.$uiBus.emit("dropup:openSelectDestination", this.shipment.id); // to open with the route
    } else {
      this.$uiBus.emit('genericError:show', this.$t('errors.validation'));
    }
  }
}
